import { render, staticRenderFns } from "./ForBusinessPage.vue?vue&type=template&id=ab7d82bc&scoped=true"
import script from "./ForBusinessPage.vue?vue&type=script&lang=js"
export * from "./ForBusinessPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7d82bc",
  null
  
)

export default component.exports